import {MachineType} from "./machine-type";

export class MachineModel {
  machineModelUuid?: string;
  modelName: string;
  description: string;
  image: string;
  machineType: MachineType;
}
